import config from '../../config';

export default {
  url: `${config.api.baseURL}/accounts/:accountId/profiles/:profileId`,
  options: {
    method: 'DELETE'
  },
  transformer(data) {
    return data;
  }
};
